/**
 * @generated SignedSource<<dbc51c8864d67c2c2b3ed9ce8d751458>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reportCategories_reportsOverviewPage$data = {
  readonly jira?: {
    readonly jiraBoard: {
      readonly reportCategories?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
          };
        } | null | undefined> | null | undefined;
      };
    };
  };
  readonly jira_projectByIdOrKey?: {
    readonly reportCategories: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly extensions: ReadonlyArray<{
          readonly statusCode: number;
        }>;
      }> | null | undefined;
    };
  };
  readonly " $fragmentType": "reportCategories_reportsOverviewPage";
};
export type reportCategories_reportsOverviewPage$key = {
  readonly " $data"?: reportCategories_reportsOverviewPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reportCategories_reportsOverviewPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = {
  "kind": "FragmentSpread",
  "name": "reportCategory_reportsOverviewPage"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "boardId"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isBoardContext"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    }
  ],
  "kind": "Fragment",
  "name": "reportCategories_reportsOverviewPage",
  "selections": [
    {
      "condition": "isBoardContext",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "idOrKey",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "JiraReportCategoryConnection",
                  "kind": "LinkedField",
                  "name": "reportCategories",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "QueryError",
                      "kind": "LinkedField",
                      "name": "errors",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "kind": "ScalarField",
                                  "name": "statusCode"
                                },
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.reportCategories.errors.extensions.statusCode"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira_projectByIdOrKey.reportCategories.errors.extensions"
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraReportCategoryEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraReportCategoryNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v0/*: any*/),
                              "action": "THROW",
                              "path": "jira_projectByIdOrKey.reportCategories.edges.node.name"
                            },
                            (v1/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                },
                "action": "THROW",
                "path": "jira_projectByIdOrKey.reportCategories"
              }
            ]
          },
          "action": "THROW",
          "path": "jira_projectByIdOrKey"
        }
      ]
    },
    {
      "condition": "isBoardContext",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "id",
                      "variableName": "boardId"
                    }
                  ],
                  "kind": "LinkedField",
                  "name": "jiraBoard",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraReportCategoryConnection",
                            "kind": "LinkedField",
                            "name": "reportCategories",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraReportCategoryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": {
                                      "concreteType": "JiraReportCategoryNode",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "RequiredField",
                                          "field": (v0/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.jiraBoard.reportCategories.edges.node.name"
                                        },
                                        (v1/*: any*/)
                                      ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraBoard.reportCategories.edges.node"
                                  }
                                ]
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.jiraBoard.reportCategories"
                        }
                      ],
                      "type": "JiraBoard"
                    }
                  ]
                },
                "action": "THROW",
                "path": "jira.jiraBoard"
              }
            ]
          },
          "action": "THROW",
          "path": "jira"
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "c24384adae5f380365f9cbf8a99e2c25";

export default node;
